import Container from '@mui/material/Container';
import { ThemeProvider } from '@mui/material/styles';
import React from 'react';
import theme from '@/theme';
import { useLocation, useNavigate } from 'react-router-dom';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import { useServices } from '@/components/ServiceContext.tsx';
import { Box } from '@mui/material';
import { reportDefinitions } from '@lambda-layer/constants/reportDefinitions';

const Breadcrumb: React.FC = () => {
  const { routeService } = useServices();

  const navigate = useNavigate();
  const location = useLocation();

  const buildPathSegments = (path: string) => {
    const segments = path.split('/').filter(Boolean);
    return segments.map((segment, index) => {
      return '/' + segments.slice(0, index + 1).join('/');
    });
  };

  const pathSegments = buildPathSegments(location.pathname);

  return (
    <ThemeProvider theme={theme}>
      <Box mb={1} mt={1}>
        <Container maxWidth={false}>
          <Link
            style={{ cursor: 'pointer' }}
            underline="none"
            onClick={() =>
              navigate(
                routeService.routes?.find(r => r.id === 'home')?.path || '/',
                {
                  viewTransition: true,
                }
              )
            }
          >
            {routeService.getRoute('home')?.label}
          </Link>
          <span style={{ color: 'darkgrey' }}>{' > '}</span>
          {pathSegments.map((segment, index) => {
            const route = routeService.routes?.find(r => {
              // Handle dynamic segments
              if (r.path?.includes(':')) {
                const basePath = r.path.split('/:')[0];
                return segment.startsWith(basePath);
              }
              return r.path === segment;
            });

            // Prefer report definition name for report routes
            let reportName: string | undefined;
            if (route?.id) {
              // Normalize id for export preview routes
              const isExportPreview = route.id.endsWith('-export-preview');
              const baseReportId = isExportPreview
                ? route.id.replace(/-export-preview$/, '')
                : route.id;
              const def = reportDefinitions.find(rd => rd.id === baseReportId);
              if (def?.reportName) {
                reportName = isExportPreview
                  ? `${def.reportName} Export Preview`
                  : def.reportName;
              }
            }

            const baseLabel =
              route?.label || segment.replace('/', '').replace(/-/g, ' ');
            const label = reportName || baseLabel;

            return (
              <React.Fragment key={index}>
                {index === pathSegments.length - 1 ? (
                  <span style={{ fontWeight: 'bold' }}>
                    {label.charAt(0).toUpperCase() + label.slice(1)}
                  </span>
                ) : (
                  <Link
                    style={{ cursor: 'pointer' }}
                    underline="none"
                    onClick={() =>
                      navigate(route?.path || '/', {
                        viewTransition: true,
                      })
                    }
                  >
                    {label.charAt(0).toUpperCase() + label.slice(1)}
                  </Link>
                )}
                {index !== pathSegments.length - 1 && (
                  <span style={{ color: 'darkgrey' }}>{' > '}</span>
                )}
              </React.Fragment>
            );
          })}
          <Box mt={1}>
            <Divider />
          </Box>
        </Container>
      </Box>
    </ThemeProvider>
  );
};

export default Breadcrumb;
